/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { withSnackbar } from 'notistack';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Alert } from "react-bootstrap";
import { injectIntl } from "react-intl";
import * as taskOrderCrud from '../../../../crud/taskOrder.crud';
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import Spinner from '../../../../partials/layout/Spinner';
import DataSource from 'devextreme/data/data_source';
import Common from '../../../../shared/common';

class AssessmentCustomForm extends React.Component {
    constructor(props) {
        super(props);
        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;
        this.createDefaultFields = ((props.location || {}).state || {});

        this.validatorRef = props.validatorRef ? props.validatorRef : React.createRef();

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        const createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        let selectedClause = null;
        const { fields } = this.props.workflowItem;

        if (createDefaultClause) {
            selectedClause = fields.CompensationType.clauses.find(
                c => c.display === createDefaultClause
            );
        }
        else if (this.props.item?.compensationtype) {
            selectedClause = fields.CompensationType.clauses.find(item => item.display === this.props.item.compensationtype);
        }

        this.state = {
            isDxFormValid: true,
            taskOrderOptions: null,
            projectOrderOptions: null,
            dateSectionFilters: [],
            selectedClause,
        };
    }

    componentDidMount() {
        if (this.props.taskOrderOptionEnabled) {
            this.fetchTaskOrders();
        }
        if (this.props.projectOrderOptionEnabled) {
            this.fetchProjectOrders();
        }
    }

    fetchTaskOrders = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await taskOrderCrud.getTaskOrdersToSelectList(contractid);
            //COVERTED TO DATASOURCE WITH FD-11007 DUE TO PERFORMENCE ISSUES AFTER 3K ITEMS
            const taskOrderOptions = new DataSource({
                store: {
                    type: 'array',
                    data: responseObj,
                    key: 'value'
                }
            });
            this.setState({ taskOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);
            const projectOrderOptions = responseObj.map(TO => {
                let displayValue = "";
                if (ispackaged) {
                    if (TO.linkedprojectcode) {
                        displayValue += `[${TO.linkedprojectcode}] - `;
                    }
                    if (TO.linkedprojectname) {
                        displayValue += `${TO.linkedprojectname} - `;
                    }
                    if (TO.projectordernumber) {
                        displayValue += `${TO.projectordernumber} - `;
                    }
                    if (TO.purchaseordervalue) {
                        displayValue += `${Common.FormatCurrencyNum(TO.purchaseordervalue, (this.props.contract || {}).currency)} - `;
                    }
                }
                displayValue += `${TO.referenceid} - ${TO.subject}`;
                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });
            this.setState({ projectOrderOptions: projectOrderOptions });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        this.state.isDxFormValid = isDxFormValid;

        if (field) {
            if (field === 'taskorderid') {
                if (value) {
                    const newItem = { sourcedmodel: "TaskOrder", sourcedrecordid: value };

                    this.setState(prevState => ({
                        dateSectionFilters: [...prevState.dateSectionFilters, newItem]
                    }));
                } else {
                    this.setState(prevState => ({
                        dateSectionFilters: prevState.dateSectionFilters.filter(
                            item => (item.sourcedmodel !== 'TaskOrder')
                        )
                    }));
                }

                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (field === 'taskorderid') {
                        if (value) {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                            if (additionalData) {
                                this.props.valueChangeHandler('taskorderreference', additionalData.referenceid, isDxFormValid, additionalData);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('taskorderid', value, isDxFormValid, additionalData);
                            this.props.valueChangeHandler('taskorderreference', "", isDxFormValid, additionalData);
                        }
                    }
                }
            }
            else if (field === 'projectorderid') {
                if (value) {
                    const newItem = { sourcedmodel: "ProjectOrder", sourcedrecordid: value };

                    this.setState(prevState => ({
                        dateSectionFilters: [...prevState.dateSectionFilters, newItem]
                    }));
                } else {
                    this.setState(prevState => ({
                        dateSectionFilters: prevState.dateSectionFilters.filter(
                            item => (item.sourcedmodel !== 'ProjectOrder')
                        )
                    }));
                }

                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);

                    if (field === 'projectorderid') {
                        if (value) {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                            if (additionalData) {
                                this.props.valueChangeHandler('projectorderreference', additionalData.referenceid, isDxFormValid, additionalData);
                            }
                        }
                        else {
                            this.props.valueChangeHandler('projectorderid', value, isDxFormValid, additionalData);
                            this.props.valueChangeHandler('projectorderreference', "", isDxFormValid, additionalData);
                        }
                    }
                }
            }
            else if (field === 'compensationtype') {
                const { fields } = this.props.workflowItem;
                const selectedClause = fields.CompensationType.clauses.find(item => item.display === value);
                this.setState({ selectedClause: selectedClause });
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
            else {
                if (this.props.valueChangeHandler) {
                    this.props.valueChangeHandler(field, value, isDxFormValid, additionalData);
                }
            }
        }
    }

    render() {
        if ((this.props.taskOrderOptionEnabled && !this.state.taskOrderOptions) ||
            (this.props.projectOrderOptionEnabled && !this.state.projectOrderOptions)) {
            return (<Spinner />);
        }

        const { fields } = this.props.workflowItem;

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { label: fields.Subject.label, dataField: 'compensationnumber', editorOptions: { defaultValue: this.createDefaultSubject } },
                { label: fields.CompensationType.label, dataField: 'compensationtype', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.CompensationType.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.state.selectedClause?.display } }
            ]
        };

        if (fields.TaskOrder.visible) {
            //AUTO-SELECT TASK ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultTaskOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'TaskOrder') {
                defaultTaskOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }

            createFormConfig.fields.push({ label: fields.TaskOrder.label, dataField: 'taskorderid', editorType: 'dxSelectBox', required: fields.TaskOrder.required, editorOptions: { dataSource: this.state.taskOrderOptions, valueExpr: 'taskorderid', displayExpr: 'display', defaultValue: defaultTaskOrderSelection } });
        }

        if (fields.ProjectOrder.visible) {
            //AUTO-SELECT PROJECT ORDER DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            let defaultProjectOrderSelection = null;
            if (this.createDefaultFields?.itemBaseProps?.reftype === 'ProjectOrder') {
                defaultProjectOrderSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            }

            createFormConfig.fields.push({ label: fields.ProjectOrder.label, dataField: 'projectorderid', editorType: 'dxSelectBox', required: fields.ProjectOrder.required, editorOptions: { dataSource: this.state.projectOrderOptions, valueExpr: 'value', displayExpr: 'display', defaultValue: defaultProjectOrderSelection } });
        }
        if (fields.AssessmentAmount.visible) {
            createFormConfig.fields.push({
                visible: this.state.selectedClause?.effect !== "EFFECT_DATES_ONLY",
                label: fields.AssessmentAmount.label,
                dataField: 'assessmentamount',
                editorType: 'dxNumberBox'
            });
        }
        if (fields.AlternativeQuotation.visible) {
            createFormConfig.fields.push({
                visible: this.state.selectedClause?.effect !== "EFFECT_AMOUNTS_ONLY",
                label: fields.AlternativeQuotation.label,
                dataField: 'alternativequotation',
                editorType: 'dxNumberBox',
                editorOptions: {
                    format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }),
                    placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' })
                }
            });
        }
        createFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' });

        return (
            <>
                {this.props.resources.SupplierClaimsWarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.SupplierClaimsWarningBanner}
                        </p>
                    </Alert>
                )}

                <BiDynamicForm
                    validatorRef={this.validatorRef}
                    item={this.props.item}
                    config={createFormConfig}
                    onSubmitHandler={this.props.onSubmitHandler}
                    valueChangeHandler={this.fieldChanged}
                    customFields={this.props.customFields}
                    assetFieldsEnabled={this.props.assetFieldsEnabled}
                    assetid={this.createDefaultAsset}
                    secondaryPriceSectionEnabled={this.state.selectedClause?.effect !== "EFFECT_DATES_ONLY"}
                    secondaryDateSectionEnabled={this.state.selectedClause?.effect !== "EFFECT_AMOUNTS_ONLY"}
                    taskorderid={this.props.item?.taskorderid}
                    projectorderid={this.props.item?.projectorderid}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    // contract: store.contract.contract,
    // contractTemplate: store.contract.template,
    // globalResources: store.contract.template.resources,
});



export default injectIntl(withSnackbar(connect(mapStateToProps)(AssessmentCustomForm)));
